import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogComponent } from 'src/app/views/share/dialog/dialog.component';
import { UserService } from 'src/services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogImageComponent } from '../../share/dialog-image/dialog-image.component';
import { UploadService } from 'src/services/upload.service';
import { DialogService } from 'src/services/dialog.service';

@Component({
  selector: 'app-scan-management',
  templateUrl: './scan-management.component.html',
  styleUrls: ['./scan-management.component.scss'],
})
export class ScanManagementComponent implements OnInit {
  // pcForm!: FormGroup;
  tab: number = 0;
  userData: any;
  userId!: string;
  loading: boolean = false;
  type: string = '';
  title: string = '';
  showScan: boolean = false;
  showResult: boolean = false;
  customer: any = {};
  ecoupon: any = {};
  quest: any = {};
  campaign: any = {};
  assistantList: any = [];
  stepScan: boolean = false;
  payload: any = {};
  uploadProgress: number = 0;
  flowSuccess: boolean = false;

  requestECouponData: any = {};
  requestQuestData: any = {};
  requestCampaignData: any = {};

  disableBtnFlowUnSuccess: boolean = true;

  selectedAssistant: any = {
    campaign: '',
    quest: '',
    coupon: '',
  };

  periodTimeList = [
    {
      id: 'NOT_OVER',
      name: 'Not Over',
    },
    {
      id: 'MORE_THAN',
      name: 'More Than',
    },
    {
      id: 'MORE_THAN_NOT_OVER',
      name: 'More than & Not over',
    },
    {
      id: 'DEFAULT',
      name: 'ไม่ตั้งเวลา',
    },
  ];

  periodTypeList = [
    {
      id: 'DAY',
      name: 'วัน',
    },
    {
      id: 'WEEK',
      name: 'สัปดาห์',
    },
    {
      id: 'MONTH',
      name: 'เดือน',
    },
    {
      id: 'YEAR',
      name: 'ปี',
    },
  ];

  startWhenList = [
    {
      id: 'START_WHEN_QUEST_CREATED',
      name: 'หลังจากเริ่ม Quest',
    },
    {
      id: 'START_WHEN_RECEIVE',
      name: 'หลังจากได้รับ',
    },
    {
      id: 'WHEN_SUBQUEST_1_SUCCESS',
      name: 'สำเร็จ Sub - Quest 1',
    },
    {
      id: 'WHEN_SUBQUEST_2_SUCCESS',
      name: 'สำเร็จ Sub - Quest 2',
    },
    {
      id: 'WHEN_SUBQUEST_3_SUCCESS',
      name: 'สำเร็จ Sub - Quest 3',
    },
    {
      id: 'WHEN_SUBQUEST_4_SUCCESS',
      name: 'สำเร็จ Sub - Quest 4',
    },
    {
      id: 'WHEN_SUBQUEST_5_SUCCESS',
      name: 'สำเร็จ Sub - Quest 5',
    },
    {
      id: 'WHEN_SUBQUEST_6_SUCCESS',
      name: 'สำเร็จ Sub - Quest 6',
    },
    {
      id: 'WHEN_SUBQUEST_7_SUCCESS',
      name: 'สำเร็จ Sub - Quest 7',
    },
    {
      id: 'WHEN_SUBQUEST_8_SUCCESS',
      name: 'สำเร็จ Sub - Quest 8',
    },
    {
      id: 'WHEN_SUBQUEST_9_SUCCESS',
      name: 'สำเร็จ Sub - Quest 9',
    },
  ];

  rewardList: any[] = [
    {
      id: 'POINT',
      name: 'Point',
    },
    {
      id: 'ECOUPON',
      name: 'E-Coupon',
    },
    {
      id: 'ECOUPON_AND_POINT',
      name: 'Point & E-Coupon',
    },
  ];
  totalJoinList: any[] = [
    {
      id: 'LIMIT',
      name: 'จำกัด',
    },
    {
      id: 'UNLIMIT',
      name: 'ไม่จำกัด',
    },
  ];
  conditionList = [
    {
      id: 'DATE_RANGE_CONDITION',
      name: 'Date range condition',
    },
    {
      id: 'ADVANCE_CONDITION',
      name: 'Advance condition',
    },
  ];

  constructor(
    private fb: FormBuilder,
    private uploadService: UploadService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.title = 'รายละเอียด PC';
    this.initData();
  }

  async initData() {
    await this.getUser();
  }

  disabledButton(param: boolean, type: number) {
    // console.log(':: disabledButton :: ', param);
    if (type === this.tab) {
      this.disableBtnFlowUnSuccess = param;
    }
  }

  updateECoupon(param: any) {
    // console.log(':: updateECoupon :: ', param);
    this.requestECouponData = param;
  }
  updateQuest(param: any) {
    // console.log(':: updateQuest :: ', param);
    this.requestQuestData = param;
  }
  updateCampaign(param: any) {
    // console.log(':: updateCampaign :: ', param);
    this.requestCampaignData = param;
  }

  getNameUseageType(type: string) {
    if (type === null) return '-';
    if (type === 'DEFAULT') return '-';
    return this.startWhenList.find((x: any) => x.id === type)?.name ?? '-';
  }

  changeTab(param: number) {
    this.tab = param;
    this.disableBtnFlowUnSuccess = true;
    // clear data
    this.stepScan = false;
    this.showScan = false;
    this.showResult = false;
    this.flowSuccess = false;
  }

  displayRewardType(param: string): string {
    return this.rewardList.find((e) => e.id == param)?.name ?? '';
  }

  displayPeriodType(param: string): string {
    return this.periodTypeList.find((e) => e.id == param)?.name ?? '';
  }

  displayPeriodTime(param: string): string {
    return this.periodTimeList.find((e) => e.id == param)?.name ?? '';
  }
  displayConditionType(param: string): string {
    return this.conditionList.find((e) => e.id == param)?.name ?? '-';
  }

  onDetect(event: any) {
    // console.log('QR Code detected: ', event);
  }

  async getUser() {
    var id = await JSON.parse(localStorage.getItem('user')!).id;
    this.userService.getMemberById(id).subscribe({
      next: (res) => {
        this.userData = res;
        console.log(this.userData);
      },
      error: (error) => this.handleError(),
    });
  }

  private handleError(errorStatus?: string, errorMessage?: string) {
    this.loading = false;
    var title = 'ไม่สามารถดำเนินการได้';
    var message = errorMessage ?? 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง';
    var clinicName = this.userData?.clinic?.name ?? '';

    var prefixName = '';
    if (this.tab == 0) {
      prefixName = 'E-coupon';
    }
    if (this.tab == 1) {
      prefixName = 'เควส';
    }
    if (this.tab == 2) {
      prefixName = 'แคมเปญ';
    }

    switch (errorStatus) {
      case 'QUEST_ALREADY_COMPLETED':
        if (this.tab == 0) {
          title = 'ใช้สิทธิ์ ' + prefixName + ' ไม่ถูกต้อง';
          message =
            'ใช้สิทธิ์ ' +
            prefixName +
            ' ไม่ถูกต้อง กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        }
        if (this.tab == 1) {
          title = 'ทำเควสนี้สำเร็จไปแล้ว';
          message = 'เคยทำเควสนี้ไปแล้ว กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        }
        if (this.tab == 2) {
          title = 'ทำแคมเปญนี้สำเร็จไปแล้ว';
          message = 'เคยทำแคมเปญนี้ไปแล้ว กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        }
        break;

      case 'alreay_expired':
        message = prefixName + ' นี้หมดอายุแล้ว';
        break;

      case 'alreay_used':
        message = prefixName + ' นีเคยถูกใช้งานไปแล้ว';
        break;

      case 'not_enough_points':
        message = 'คะแนนของลูกค้าไม่เพียงพอ';
        break;

      case 'status_or_redeem_status_not_active':
        message = 'สถานะการใช้งานหรือสถานะการ redeem ถูกปิด';
        break;

      case 'wrong_qr_code':
        title = 'QR code ไม่ถูกต้อง';
        message = 'QR code ไม่ถูกต้อง กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        break;

      case 'CLINIC_CANNOT_USE':
        title = 'คลินิกไม่มีสิทธิ์';
        message = 'คลินิกไม่มีสิทธิ์ กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        break;

      case 'e_coupon_is_not_available_for_this_clinic_or_branch':
        message = 'This e-coupon is not available for this clinic or branch';
        break;

      case 'batch_code_size_not_match':
        message = 'This e-coupon is not available for this clinic or branch';
        break;

      case 'e_coupon_is_not_active_or_not_valid_for_the_current_date':
        message =
          'This e-coupon is not active or not valid for the current date';
        break;

      case 'no_receive_date_found_in_e_coupon-history':
        message = 'No receive date found in e-coupon history';
        break;

      case 'invalid_periodTime_or_periodType':
        message = 'Invalid periodTime or periodType';
        break;

      case 'e_coupon_is_outside_the_valid_usage_period':
        message =
          'This e-coupon cannot be used as it is outside the valid usage period';
        break;

      case 'e_coupon_exceeded_the_valid_period':
        message =
          'This e-coupon cannot be used as it has exceeded the valid period';
        break;

      case 'e_coupon_valid_period_has_not_been_reached':
        message =
          'This e-coupon cannot be used as the valid period has not been reached';
        break;

      case 'e_coupon_outside_the_valid_usage_period':
        message =
          'This e-coupon cannot be used as it is outside the valid usage period';
        break;

      case 'outside_valid_usage_period_time':
        message =
          'This e-coupon cannot be used as it is outside the valid usage period';
        break;

      case 'QUEST_NOT_STARTED':
        message = 'This quest is not start';
        break;

      case 'quata_full':
        if (this.tab == 1) {
          title = 'สิทธิ์การใช้ ' + prefixName + ' เต็ม';
          message =
            'คลินิก: ' +
            clinicName +
            ' สิทธิ์ในการให้บริการครบจำนวนแล้ว กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        } else {
          title = 'สิทธิ์การเข้าร่วม' + prefixName + 'เต็ม';
          message =
            prefixName +
            'นี้คลินิก: ' +
            clinicName +
            ' สิทธิ์ในการให้บริการครบจำนวนแล้ว กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        }
        break;

      case 'QUEST_EXPIRED':
        message = 'หมดเวลาเข้าร่วม' + prefixName;
        message =
          'หมดเวลาเข้าร่วม' + prefixName + ' กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        break;

      case 'QUEST_INACTIVE':
        message = prefixName + ' สถานะการใช้งาน ถูกปิด';
        break;

      case 'SUBQUEST_PERIOD_NOT_REACHED':
        message =
          'Sub-quest validation failed: minimum time period not reached.';
        break;

      case 'SUBQUEST_PERIOD_EXPIRED':
        message = 'Sub-quest time has expired.';
        break;

      case 'CLINIC_CANNOT_USE':
        title = 'ไม่มีสิทธิ์การทำ' + prefixName;
        message =
          'ไม่มีสิทธิ์การทำ' + prefixName + ' กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        break;

      case 'not_match':
        title = prefixName + ' และ Batch Code ไม่ถูกต้อง';
        message =
          prefixName +
          ' และ Batch Code ไม่ถูกต้อง กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        break;

      case 'PC_USER_UNAUTHORIZED':
        message = 'ลูกค้าไม่มีสิทธิ์';
        message = 'ลูกค้าไม่มีสิทธิ์ กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        break;

      case 'CUSTOMER_NOT_FOUND':
        title = 'พบข้อผิดพลาด ไม่พบลูกค้าในฐานข้อมูล';
        message = 'ไม่พบลูกค้าในฐานข้อมูล กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        break;

      case 'CAMPAIGN_INACTIVE':
        title = 'แคมเปญครบสิทธิ์แล้ว';
        message =
          'ไม่มีสิทธิ์เข้าร่วมแคมเปญ เนื่องจากได้เข้าร่วมกิจกรรมครบจำนวนที่กำหนดแล้ว ขอเชิญร่วมกิจกรรมใหม่ในโอกาสถัดไป';
        break;

      case 'CAMPAIGN_EXPIRED':
        title = 'แคมเปญหมดอายุ';
        message = 'แคมเปญหมดอายุ กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        break;

      case 'CLINIC_NOT_FOUND':
        title = 'คลินิกไม่มีสิทธิ์';
        message = 'คลินิกไม่มีสิทธิ์ กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        break;

      case 'CAMPAIGN_ALREADY_COMPLETED':
        message = 'The campaign has reach clinic quota.';
        break;

      case 'CAMPAIGN_ALREADY_COMPLETED_QUOTA':
        message = 'The user has reached the quota limit for this campaign.';
        break;

      case 'SUBQUEST_PERIOD_NOT_MORE_THAN':
        message = 'Sub-quest time must exceed the minimum period.';
        break;

      default:
        break;
    }

    this.dialogService.openDialog(
      {
        action: 'fail',
        title: title,
        message: message,
      },
      () => null
    );
  }

  async submit() {
    // stepScan
    if (this.tab == 0) {
      if (this.stepScan) {
        this.loading = true;
        await this.userService.scanECoupon(this.payload).subscribe({
          next: (res) => {
            this.loading = false;
            // console.log(res);

            if (res.status != 200) {
              this.resetStep();
              this.handleError(res.errorCode, res.message);
              return;
            }

            this.dialogService.openDialog(
              {
                action: 'success',
                title: 'รับคะแนนสำเร็จ',
                message: 'รับคะแนนจาก E-coupon สำเร็จ กรุณาตรวจสอบข้อมูล',
              },
              (res) => {
                if (res) {
                  //
                  this.tab = 0;
                  this.stepScan = false;
                  this.showScan = false;
                  this.showResult = false;
                  this.flowSuccess = false;
                }
                // this.dialogService.openDialog(
                //   {
                //     action: 'success',
                //     title: 'ได้รับคะแนนสำเร็จ',
                //     message: 'PC ได้รับคะแนนจาก E-coupon สำเร็จ จำนวน xxx',
                //   },
                //   () => null
                // );
              }
            );
          },
          error: (error) => {
            this.loading = false;
            this.showScan = false;
            this.handleError(error.error.errorCode, error.error.errorMessage);
          },
        });
      } else {
        this.showScan = true;
        this.stepScan = true;
      }
    }
    if (this.tab == 1) {
      if (this.stepScan) {
        await this.userService.scanQuest(this.payload).subscribe({
          next: (res) => {
            this.loading = false;
            // console.log(res);

            if (res.status != 200) {
              this.resetStep();
              this.handleError(res.errorCode, res.message);
              return;
            }

            let title = 'ทำเควสสำเร็จ';
            let message = '';
            if (this.quest.rewardType == 'POINT') {
              message = 'ได้รับคะแนนจากการทำเควสสำเร็จ';
            }
            if (this.quest.rewardType == 'ECOUPON') {
              message = 'ได้รับ E-coupon จากการทำเควสสำเร็จ';
            }
            if (this.quest.rewardType == 'ECOUPON_AND_POINT') {
              message = 'ได้รับ E-coupon & คะแนน จากการทำเควสสำเร็จ';
            }

            if (
              res.message ==
              'Sub-quest scanned successfully, proceeding to next.'
            ) {
              message = 'รับเควส ' + this.quest?.name + ' สำเร็จ';
              title = 'รับเควสสำเร็จ';
            }

            this.dialogService.openDialog(
              {
                action: 'success',
                title: title,
                message: message,
              },
              (res) => {
                if (res) {
                  //
                  this.tab = 1;
                  this.stepScan = false;
                  this.showScan = false;
                  this.showResult = false;
                  this.flowSuccess = false;
                }
              }
            );
          },
          error: (error) => {
            this.loading = false;
            this.showScan = false;
            this.handleError(error.error.errorCode, error.error.errorMessage);
          },
        });
      } else {
        this.loading = false;
        this.showScan = true;
        this.stepScan = true;
      }
    }
    if (this.tab == 2) {
      if (this.stepScan) {
        await this.userService.scanCampaign(this.payload).subscribe({
          next: (res) => {
            this.loading = false;
            // console.log(res);

            if (res.status != 200) {
              this.resetStep();
              this.handleError(res.errorCode, res.message);
              return;
            }

            this.dialogService.openDialog(
              {
                action: 'success',
                title: 'ทำแคมเปญสำเร็จ',
                message: 'ได้รับคะแนนจากการเข้าร่วมแคมเปญสำเร็จ',
              },
              (res) => {
                if (res) {
                  //
                  this.tab = 2;
                  this.stepScan = false;
                  this.showScan = false;
                  this.showResult = false;
                  this.flowSuccess = false;
                }
              }
            );
          },
          error: (error) => {
            this.loading = false;
            this.showScan = false;
            this.handleError(error.error.errorCode, error.error.errorMessage);
          },
        });
      } else {
        this.loading = false;
        this.showScan = true;
        this.stepScan = true;
      }
    }
  }

  clickIn(event: Event) {
    event.stopPropagation(); // หยุดการแพร่กระจายของเหตุการณ์คลิก
  }

  callBackScan(data: any) {
    if (data.status == 'close') {
      this.showScan = false;
      this.stepScan = false;
      return;
    }
    // this.showResult = true;
    // this.tab = 2;
    // data.status = 'success'
    // this.showScan = false;
    // this.campaign.coverUrl = 'https://merz-sub-bucket.s3.ap-southeast-2.amazonaws.com/82c48eef-176d-40d1-b57f-c5af4bd26197-459649065_122109507158508003_3213250138593119486_n.jpg';
    // return;
    this.showScan = false;
    // console.log('callBackScan:', data);
    if (data.status === 'success') {
      // chack qr code เป็นของระบบไหม
      // check qr code กับ รายการที่เลือกตรงกันไหม
      if (this.checkWrongQrCode(data.value)) {
        this.stepScan = false;
        return;
      }

      // check batch code
      if (this.checkBatchCode()) {
        this.stepScan = false;
        return;
      }

      this.loading = true;
      // e-coupon
      if (this.tab == 0) {
        console.log('e-coupon');
        this.callPreScanEcoupon(data);
      }
      // e-quest
      if (this.tab == 1) {
        console.log('quest');
        this.callPreScanQuest(data);
      }
      // e-campaign
      if (this.tab == 2) {
        console.log('campaign');
        this.callPreScanCampaign(data);
      }
    } else if (data.status === 'error') {
      this.resetStep();
      this.dialogService.openDialog(
        {
          action: 'fail',
          title: 'ไม่สามารถดำเนินการได้',
          message: data.value,
        },
        () => null
      );
    }
  }

  checkBatchCode(): boolean {
    var title = '';
    var message = '';
    if (this.tab == 0) {
      if (this.requestECouponData.ecouponBacthCode) {
        if (!this.requestECouponData.batchCodePass) {
          title = 'E-Coupon และ Batch code ไม่ถูกต้อง';
          message =
            'E-Coupon และ Batch code ไม่ถูกต้อง กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        }
      }
    }
    if (this.tab == 1) {
      if (this.requestQuestData.questBatchCode) {
        if (!this.requestQuestData.batchCodePass) {
          title = 'เควส และ Batch code ไม่ถูกต้อง';
          message =
            'เควส และ Batch Code ไม่ถูกต้อง กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        }
      }
    }
    if (this.tab == 2) {
      if (this.requestCampaignData.campaignBatchCode) {
        if (!this.requestCampaignData.batchCodePass) {
          title = 'แคมเปญ และ Batch Code ไม่ถูกต้อง';
          message =
            'แคมเปญ และ Batch code ไม่ถูกต้อง กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง';
        }
      }
    }
    if (title != '' && message != '') {
      this.dialogService.openDialog(
        {
          action: 'fail',
          title: title,
          message: message,
        },
        () => null
      );
      return true;
    }
    return false;
  }

  checkWrongQrCode(data: any): boolean {
    try {
      console.log('data:', data);

      var parsed = JSON.parse(data) ?? '';
      // console.log('parsed:', parsed);

      // chack qr code เป็นของระบบไหม
      if (!parsed.qrPassphase) {
        this.handleError('wrong_qr_code');
        this.stepScan = false;
        return true;
      }

      // check qr code กับ รายการที่เลือกตรงกันไหม
      if (this.tab == 0) {
        if (this.requestECouponData.coupon != parsed.ecouponId) {
          this.handleError('not_match');
          return true;
        }
      }

      if (this.tab == 1) {
        if (this.requestQuestData.quest != parsed.questId) {
          this.handleError('not_match');
          return true;
        }
      }

      if (this.tab == 2) {
        if (this.requestCampaignData.campaign != parsed.campaignId) {
          this.handleError('not_match');
          return true;
        }
      }
      return false;
    } catch (error) {
      this.handleError('wrong_qr_code');
      return true;
    }
    return false;
  }

  callPreScanEcoupon(data: any) {
    this.payload = {
      ...JSON.parse(data.value),
      batchCode: this.requestECouponData.batchCode,
      slipUrl: this.requestECouponData.imageUrl,
      assistantPc: this.requestECouponData.assistantPc,
      clinicBranchId: this.userData?.clinicBranch?.id ?? '',
      clinicId: this.userData?.clinic?.id ?? '',
      // "eCouponId": 75018287,
      // "customerId": 16046688,
      // "qrPassphase": "86d23db5-ef73-4a54-8a1b-a0a208e9b974",
    };
    this.userService.preScanEcoupon(this.payload).subscribe({
      next: (res) => {
        // console.log('res:', res);
        if (res.status == 'error') {
          this.resetStep();
          this.handleError('wrong_qr_code');
          return;
        }
        this.customer = res.data.customer;
        this.ecoupon = res.data.ecoupon;
        this.showResult = true;
        this.stepScan = true;
        this.loading = false;
        // console.log(this.ecoupon);
      },
      error: (error) => {
        this.loading = false;
        this.resetStep();
        this.handleError(error.error.errorCode, error.error.errorMessage);
      },
    });
  }

  callPreScanQuest(data: any) {
    this.payload = {
      ...JSON.parse(data.value),
      batchCode: this.requestQuestData.batchCode,
      slipUrl: this.requestECouponData.imageUrl,
      assistantPc: this.requestQuestData.assistantPc,
      // clinicBranchId: this.userData?.clinicBranch?.id ?? '',
      clinicId: this.userData?.clinic?.id ?? '',
    };
    this.userService.preScanQuest(this.payload).subscribe({
      next: (res) => {
        // console.log('res:', res);
        if (res.status == 'error') {
          this.resetStep();
          this.handleError('wrong_qr_code');
          return;
        }
        this.customer = res.data?.customer;
        this.quest = res.data?.quest;
        this.quest.ecouponName = res.data?.ecouponName
        this.loading = false;
        this.showResult = true;
        this.stepScan = true;
      },
      error: (error) => {
        // console.log('error:', error.error.errorCode);
        this.loading = false;
        this.resetStep();
        this.handleError(error.error.errorCode, error.error.errorMessage);
      },
    });
  }

  callPreScanCampaign(data: any) {
    // this.payload = {
    //   "campaignId": 17,
    //   "batchCode": "TESTA",
    //   "slipUrl": "test",
    //   "assistantPc": "test",
    //   "customerId": 83,
    //   "qrPassphase": "86d23db5-ef73-4a54-8a1b-a0a208e9b974"
    // }
    this.payload = {
      ...JSON.parse(data.value),
      batchCode: this.requestCampaignData.batchCode,
      assistantPc: this.requestCampaignData.assistantPc,
      // slipUrl: this.previewUrl,
    };
    this.userService.preScanCampaign(this.payload).subscribe({
      next: (res) => {
        // console.log('res:', res);
        if (res.status == 'error') {
          this.resetStep();
          this.handleError('wrong_qr_code');
          return;
        }
        this.customer = res.data?.customer;
        this.campaign = res.data?.campaign;
        this.loading = false;
        this.showResult = true;
        this.stepScan = true;
      },
      error: (error) => {
        this.loading = false;
        this.resetStep();
        this.handleError(error.error.errorCode, error.error.errorMessage);
      },
    });
  }

  resetStep() {
    this.showResult = false;
    this.stepScan = false;
  }

  openDialog(data: any, callback: (data: boolean) => void): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '520px',
      data,
    });
    dialogRef
      .afterClosed()
      .subscribe((result) => callback(result === 'confirm'));
  }

  openScanDialog(data: any, callback: (data: boolean) => void): void {
    const dialogRef = this.dialog.open(DialogImageComponent, {
      width: '500px',
      data,
    });
    dialogRef
      .afterClosed()
      .subscribe((result) => callback(result === 'confirm'));
  }
}
